import React from 'react';
import { useSelector } from 'react-redux';

import { ListHorizontal } from 'ui/components';
import { SkeletonText } from 'ui/components/skeleton';
import { formatDate } from 'utilities/common';


export const DetailQuotation = ({ data }) => {
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['Quotation.Show']
  );

  const dummy = Array.from({ length: 10 }, (v, i) => i);

  return (
    <section id="quotation">
      <div className="row mb-4">
        {StateLoading || !data ? (
          dummy?.map((d, i) => (
            <div className="col-md-6 col-12" key={i}>
              <SkeletonText count={1} />
            </div>
          ))
        ) : (
          <div className='py-2 px-3'>
            <ListHorizontal
              title="Client"
              content={
                data?.customer?.company_name !== ''
                ? `${data?.customer?.company_name} - ${data?.customer?.name}`
                : data?.customer?.name
              }
            />
            <ListHorizontal
              title="Sales Ref"
              content={data?.created_by}
            />
            <ListHorizontal
              title="Date"
              content={formatDate(data?.created_at, 'YYYYMM')}
            />
          </div>
        )}
      </div>
    </section>
  );
};

export const DetailNote = ({ data }) => {
  return (
    <section id="note" className='mt-3'>
      <div className='border rounded-2'>
        <div className="table-responsive m-0">
          <table
            width="100%"
            className="table table-vcenter card-table datatable border"
          >
            <thead className="bg-light">
              <tr className="th">
                <td style={{ whiteSpace: 'initial'}}>
                  TERMS OF SERVICE
                </td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ whiteSpace: 'pre-wrap'}}>
                  {data?.terms_of_service}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
};
